import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function AnonymousModeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 36.764 53.705">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36.764"
        height="53.705"
        viewBox="0 0 36.764 53.705"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Retângulo_151"
              data-name="Retângulo 151"
              width="36.764"
              height="53.705"
              fill="#322b2d"
            />
          </clipPath>
        </defs>
        <g id="Grupo_383" data-name="Grupo 383" opacity="0.91">
          <g id="Grupo_382" data-name="Grupo 382" clipPath="url(#clip-path)">
            <path
              id="Caminho_84"
              data-name="Caminho 84"
              d="M9.6,31.382a.982.982,0,1,0,.982.982.982.982,0,0,0-.982-.982"
              transform="translate(-4.646 -16.921)"
              fill="#322b2d"
            />
            <path
              id="Caminho_85"
              data-name="Caminho 85"
              d="M34.728,35.75a.921.921,0,0,0-.4,1.241,14.666,14.666,0,0,1,1.646,6.787c0,6.557-5.368,15.448-15.958,26.432C12.081,61.114,4.846,51.666,4.5,43.738a13.349,13.349,0,0,1,1.316-6.421.922.922,0,1,0-1.663-.8,15.188,15.188,0,0,0-1.5,7.3c.385,8.716,8.224,18.781,16.639,28.359l.657.747.695-.711C37.821,54.625,37.821,46.461,37.821,43.778a16.488,16.488,0,0,0-1.852-7.632.921.921,0,0,0-1.241-.4"
              transform="translate(-1.423 -19.221)"
              fill="#322b2d"
            />
            <path
              id="Caminho_86"
              data-name="Caminho 86"
              d="M14.09,31.831a13.758,13.758,0,1,0,24.544,9.924.921.921,0,1,0-1.832-.2A11.928,11.928,0,0,1,21.26,51.611a11.916,11.916,0,0,1-7.636-15.022,11.985,11.985,0,0,1,.693-1.663,2.6,2.6,0,0,0,2.248,1.846,3.746,3.746,0,0,0,.625.052H21.72c1.609,0,2.913-1,2.913-2.244v-3.81H26.1v3.81c0,1.24,1.3,2.244,2.913,2.244h4.531c1.609,0,2.913-1,2.913-2.244v-3.81H38.2a.922.922,0,1,0,0-1.843H13.257a.922.922,0,0,0,0,1.843h1.02v.887a.906.906,0,0,0-.187.175m12.638,3.941a.221.221,0,0,1-.051.046,2.221,2.221,0,0,1-.288-.368l.018-.027,2.671-4.007a.23.23,0,1,1,.383.256Zm3.758-2.9L27.97,36.643a3.37,3.37,0,0,1-.445-.164L30.1,32.613a.23.23,0,1,1,.383.255M14.655,35.642l2.607-3.911a.23.23,0,1,1,.383.255L14.971,36a2.3,2.3,0,0,1-.316-.357M18.7,33.73l-2.016,3.025c-.043-.006-.087-.009-.129-.017a3.537,3.537,0,0,1-.357-.084l2.12-3.18a.23.23,0,0,1,.383.256"
              transform="translate(-6.032 -15.597)"
              fill="#322b2d"
            />
            <path
              id="Caminho_87"
              data-name="Caminho 87"
              d="M35.843,10.7H31.873L29.487,3.079A4.368,4.368,0,0,0,24.658.048L17.137,1.157A7.081,7.081,0,0,1,13.495.734,3.688,3.688,0,0,0,8.654,2.946L5.945,10.7H.922a.922.922,0,1,0,0,1.843H35.843a.922.922,0,1,0,0-1.843M10.394,3.554a1.844,1.844,0,0,1,2.421-1.106,8.937,8.937,0,0,0,4.591.533l7.521-1.109a2.536,2.536,0,0,1,2.8,1.758L29.942,10.7H7.9Z"
              transform="translate(0 0)"
              fill="#322b2d"
            />
            <path
              id="Caminho_88"
              data-name="Caminho 88"
              d="M57.024,11.9l-1.486-4.21a.922.922,0,1,0-1.738.613l1.486,4.21a.922.922,0,1,0,1.738-.613"
              transform="translate(-28.98 -3.816)"
              fill="#322b2d"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  )
}
